import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import moment from "moment";
import $ from "jquery";
import Creatable from "react-select/creatable";
import { minDate } from "../../Constants/Constants";

const UpdateGovtOrder = ({ rowId, setRowId, getData }) => {
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const user_id = Cookies.get("users_id")?.replace(/"/g, "");
  const token = Cookies.get("token")?.replace(/"/g, "");
  const [selectedCompanyId, setSelectedCompanyId] = useState("");
  const [company, setCompany] = useState([]);
  const [product, setProduct] = useState([]);
  const [productId, setProductId] = useState("");
  const formRef = useRef(null);
  const [govtOrder, setGovtOrder] = useState([]);
  const [alloted, setAlloted] = useState([]);
  const [storeDiscom, setStoreDiscom] = useState([]);
  const [discomId, setDiscomId] = useState(null);
  const dateFormet = moment(govtOrder.rca_date).format("YYYY-MM-DD");
  function resetFileds() {
    setGovtOrder({
      company_id: "",
      product_name_id: "",
      o_m_circle: "",
      rca_number: "",
      rca_date: "",
      alloted_qty: "",
      status: "",
      bg_status: "",
      bg_amount: "",
      bg_number:"",
      validity:""
    });
    setSelectedCompanyId("");
    setProduct([]);
    setAlloted([{ product_name_id: "", alloted_qty: "" }]);
    setRowId("");
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setGovtOrder((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleDiscomChange = (selectedOption) => {
    if (selectedOption) {
      setDiscomId(selectedOption);
    } else {
      setDiscomId(null);
    }
  };

  const handleCreateOption = async (inputValue) => {
    const newOption = { value: inputValue, label: inputValue };
    const success = await addDiscomData(newOption);
    if (success) {
      setStoreDiscom((prevOptions) => [...prevOptions, newOption]);
      setDiscomId(newOption);
    }
  };

  useEffect(() => {
    if (govtOrder) {
      setAlloted(govtOrder.alloted_details || []);
    }
  }, [govtOrder]);

  const getSingleGovtOrderDetails = async () => {
    const BASE_URL = `${SERVER_URL}/api/govt-order/single-govt-order/${user_id}/${rowId}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if (res.ok) {
      setGovtOrder(result.data);
      const formattedDiscoms = {
        value: result.data.discom_id,
        label: result.data.discomList?.discom_name,
      };
      setDiscomId(formattedDiscoms);
    } else {
      setGovtOrder(null);
    }
  };
  useEffect(() => {
    if (rowId) {
      getSingleGovtOrderDetails();
    }
  }, [rowId]);

  useEffect(() => {
    if (govtOrder) {
      setSelectedCompanyId(govtOrder.company_id);
    }
  }, [govtOrder]);

  const getCompany = async () => {
    const BASE_URL = `${SERVER_URL}/api/company/all-company-details/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if (res.ok) {
      setCompany(result.data);
    } else {
      setCompany([]);
    }
  };

  useEffect(() => {
    getCompany();
  }, []);
  function handleCompanyChange(companyId) {
    if (companyId) {
      setSelectedCompanyId(parseInt(companyId));
      const updatedAlloted = alloted?.map((item) => {
        return { product_name_id: "", alloted_qty: item.alloted_qty };
      });
      setAlloted(updatedAlloted);
    }
    getProductDetails();
  }
  const getProductDetails = async () => {
    const BASE_URL = `${SERVER_URL}/api/product/drop-products/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "POST",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        company_id: selectedCompanyId,
      }),
    });
    const result = await res.json();
    if (res.ok) {
      setProduct(result.data);
    } else {
      setProduct([]);
    }
  };

  useEffect(() => {
    if (selectedCompanyId) {
      getProductDetails();
    }
  }, [selectedCompanyId]);

  const handleChangeInput = (index, event) => {
    const values = [...alloted];
    if (event.target.name === "product_name_id") {
      values[index].product_name_id = event.target.value;
    } else {
      values[index].alloted_qty = event.target.value;
    }
    setAlloted(values);
  };

  const handleAddFields = () => {
    setAlloted([...alloted, { product_name_id: "", alloted_qty: "" }]);
  };

  const closeModal = () => {
    $(".custon-close-button-color").trigger("click");
  };

  const handleClose = (index) => {
    const values = [...alloted];
    values.splice(index, 1);
    setAlloted(values);
  };

  const handleUpdateDataSubmit = async (e) => {
    e.preventDefault();
    const isAnyProductIdEmpty = alloted.some(
      (item) => item.product_name_id === ""
    );

    if (isAnyProductIdEmpty) {
      toast.error("Please select a product for all entries.");
      return;
    }
    const {
      company_id,
      o_m_circle,
      rca_number,
      rca_date,
      id,
      status,
      bg_amount,
      bg_status,
      bg_number,
      validity
    } = govtOrder;

    let BASE_URL = `${SERVER_URL}/api/govt-order/govt-order/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "PUT",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: id,
        company_id: selectedCompanyId,
        alloted_details: alloted,
        discom_id: discomId?.value,
        o_m_circle,
        rca_number,
        rca_date,
        bg_number,
        validity,
        bg_amount: bg_amount? bg_amount : 0,
        bg_status,
        status: status == "false" || !status ? "false" : "true",
      }),
    });
    const response = await res.json();
    if (res.ok) {
      resetFileds();
      closeModal();
      getData();
      setTimeout(() => {
        toast.success(response.message);
      }, 1000);
    } else {
      toast.error(response.message);
    }
  };

  const getDiscomData = async () => {
    const BASE_URL = `${SERVER_URL}/api/discom/all-discoms/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if (res.ok) {
      const formattedDiscoms = result.data.map((discom) => ({
        value: discom.id,
        label: discom.discom_name,
      }));
      setStoreDiscom(formattedDiscoms);
    } else {
      setStoreDiscom([]);
    }
  };

  useEffect(() => {
    getDiscomData();
  }, []);

  const addDiscomData = async (newDiscom) => {
    const BASE_URL = `${SERVER_URL}/api/discom/discom-list/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "POST",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        discom_name: newDiscom.label,
      }),
    });
    const result = await res.json();
    if (res.ok) {
      toast.success(result.message);
      return true;
    } else {
      toast.error(result.message);
      return false;
    }
  };

  return (
    <>
      <div
        className="modal custom-modal fade"
        id="updateModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        data-backdrop="static"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="imageZoomModalTitle">
                Update RCA
              </h5>
              <button
                type="button"
                className="custon-close-button-color close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={resetFileds}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="col-12 grid-margin">
                <div className="card">
                  <div className="card-body">
                    <form
                      className="form-sample"
                      ref={formRef}
                      onSubmit={handleUpdateDataSubmit}
                    >
                      <div className="row">
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="party">Region</label>
                            <Creatable
                              placeholder="Select or add circle"
                              onChange={handleDiscomChange}
                              onCreateOption={handleCreateOption}
                              options={storeDiscom}
                              isSearchable
                              isClearable
                              value={discomId ? discomId : null}
                              required
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="Pole">Company Name</label>
                            <select
                              type="text"
                              className="form-control form-control-lg"
                              name="company_id"
                              id="company_id"
                              onChange={(e) =>
                                handleCompanyChange(e.target.value)
                              }
                              value={selectedCompanyId}
                              required
                            >
                              <option value="">Select Company</option>
                              {company &&
                                company?.length > 0 &&
                                company?.map((item, id) => (
                                  <option
                                    value={item.id}
                                    key={id}
                                  >{`${item.company_name}, ${item.location}`}</option>
                                ))}
                            </select>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="Pole">Status</label>
                            <select
                              type="text"
                              className="form-control form-control-lg"
                              name="status"
                              id="company_id"
                              value={govtOrder.status}
                              placeholder="Status"
                              onChange={handleChange}
                            >
                              <option value={"false"}>Active</option>
                              <option value={"true"}>Inactive</option>
                            </select>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="date">Date</label>
                            <input
                              type="date"
                              className="form-control"
                              name="rca_date"
                              value={dateFormet}
                              id="date"
                              placeholder="Date"
                              max={new Date().toISOString().split("T")[0]}
                              onChange={handleChange}
                              required
                              autoComplete="off"
                              min={minDate}
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="rca">RCA.NO</label>
                            <input
                              type="text"
                              className="form-control"
                              name="rca_number"
                              value={govtOrder.rca_number}
                              id="rca"
                              placeholder="RCA.NO"
                              onChange={handleChange}
                              required
                              autoComplete="off"
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="bg_status">BG Status</label>
                            <select
                              type="text"
                              className="form-control form-control-lg"
                              name="bg_status"
                              value={govtOrder.bg_status}
                              onChange={handleChange}
                              id="bg_status"
                            >
                              <option value="0">Not Submited</option>
                              <option value="1">Submited</option>
                            </select>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="amount">BG Amount</label>
                            <input
                              type="number"
                              className="form-control"
                              name="bg_amount"
                              value={govtOrder.bg_amount}
                              id="amount"
                              placeholder="BG Amount"
                              onChange={handleChange}
                              autoComplete="off"
                              min="0"
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="bg_number">BG Number</label>
                            <input
                              type="text"
                              className="form-control"
                              name="bg_number"
                              value={govtOrder.bg_number}
                              id="bg_number"
                              placeholder="BG Number"
                              onChange={handleChange}
                              autoComplete="off"
                              min="0"
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="validity">Validity</label>
                            <input
                              type="text"
                              className="form-control"
                              name="validity"
                              value={govtOrder.validity}
                              id="validity"
                              placeholder="Validity"
                              onChange={handleChange}
                              autoComplete="off"
                              min="0"
                            />
                          </div>
                        </div>
                      </div>
                    
                      {alloted &&
                        alloted?.length > 0 &&
                        alloted?.map((item, index) => (
                          <div className="row" key={index}>
                            <div className="col-md-6">
                              <div className="form-group">
                                <label htmlFor={`product-${index}`}>Size</label>
                                <select
                                  className="form-control form-control-lg"
                                  onChange={(event) =>
                                    handleChangeInput(index, event)
                                  }
                                  name="product_name_id"
                                  value={item.product_name_id}
                                  id={`product_name_id-${index}`}
                                  required
                                >
                                  <option value="">Select Product</option>
                                  {product?.map((productItem, productIndex) => (
                                    <option
                                      value={productItem.id}
                                      key={productIndex}
                                    >{`${productItem.size}`}</option>
                                  ))}
                                </select>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group">
                                <label htmlFor={`alloted-${index}`}>
                                  Alloted
                                </label>
                                <div className="input-group">
                                  <input
                                    type="number"
                                    className="form-control"
                                    name="alloted_qty"
                                    id={`alloted-${index}`}
                                    value={item.alloted_qty}
                                    placeholder="Alloted"
                                    onChange={(event) =>
                                      handleChangeInput(index, event)
                                    }
                                    autoComplete="off"
                                    required
                                  />
                                  <span className="input-group-append ml-2">
                                    <div className="col-md-2">
                                      <button
                                        type="button"
                                        title="Remove"
                                        className="btn btn-outline-danger btn-rounded btn-icon"
                                        disabled={index > 0 ? false : true}
                                        onClick={() => handleClose(index)}
                                      >
                                        <span className="mdi mdi-close-thick"></span>
                                      </button>
                                    </div>
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      <span className="input-group-append ml-2">
                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={handleAddFields}
                        >
                          Add More
                        </button>
                      </span>
                      <button
                        className="btn btn-primary mr-2 mt-3"
                        type="submit"
                        // onClick={handleUpdateDataSubmit}
                      >
                        Save
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UpdateGovtOrder;
